


















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { orcamentoAutoOnlineService } from "@/service/orcamento-auto-online/OrcamentoAutoOnlineService";
import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import axios from "axios";

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ListaOficinas extends Vue {
  cabecalho = [
    { text: "CPF / CNPJ", value: "CNPJ", width: "20%" },
    { text: "Nome", value: "nomeFantasia", width: "20%" },
    { text: "Categoria", value: "oficinaTipo", sortable: false, width: "25%"}
  ];

  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  switchPrestador = true;

  beforeRouteEnter(to: any, from: any, next: any) {
    next();
  }

  oficinas = [];

  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  estado: EstadosCidades = {cidades: [], sigla: "", nome: ""};
  cidade: string = "";
  loading = false;
  
  mounted() {
    axios
      .get<EstadosCidadesResponse>("/administrativo/json/estados-cidades.json")
      .then((resp) => (this.estados = resp.data.estados));
  }

  @Watch("estado")
  selectCities() {
    this.cidades = [];
    this.cidade = "";
    if (this.estado) {
      this.cidades = this.estados.filter(
        (v) => v.sigla === this.estado?.sigla
      )[0].cidades;
    } else {
       this.estado = {cidades: [], sigla: "", nome: ""};
    }
  }

  filtrar() {
    if (!this.filtroPreenchido()) {
      this.openDialog(
        "error",
        "Informe o filtro",
        "Informe todos os filtros."
      );
    } else {
      this.obterOficinas();
    }
  }

  obterOficinas() {
    this.loading = true;
    orcamentoAutoOnlineService
      .obterOficinas(this.cidade, this.estado.sigla)
      .then((res) => {
        this.oficinas = res;
        if (this.oficinas.length < 1) {
          this.openDialog(
            "error",
            "Oficina Indisponível",
            "Oficinas indisponíveis para a sua região!."
          );
        } else {
          this.oficinas.sort((a: any, b: any) => {
          return a.nomeFantasia < b.nomeFantasia
            ? -1
            : a.nomeFantasia > b.nomeFantasia 
              ? 1
              : 0;
          })
        }
      })
      .catch((err) => {
        this.openDialog(
            "error",
            "Oficina Indisponível",
            "Oficinas indisponíveis tente novamente mais tarde!."
          );
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private filtroPreenchido(): boolean {
    return (!!this.cidade && !!this.cidade.trim()) &&
      (!!this.estado && !!this.estado.sigla);
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
